const runtimeConfig = typeof window !== 'undefined' ? (window.__APP_CONFIG__ ?? {}) : {};

const readConfig = (key, fallback = '') => {
  const runtimeValue = runtimeConfig[key];
  if (typeof runtimeValue === 'string' && runtimeValue.trim() !== '') {
    return runtimeValue;
  }

  const buildTimeValue = process.env[key];
  if (typeof buildTimeValue === 'string' && buildTimeValue.trim() !== '') {
    return buildTimeValue;
  }

  return fallback;
};

const appConfig = Object.freeze({
  apiBaseUrl: readConfig('REACT_APP_API_BASE_URL'),
  appEnv: readConfig('REACT_APP_NODE_ENV', 'production'),
  brandEmail: readConfig('REACT_APP_BRAND_EMAIL'),
  brandFaviconPath: readConfig('REACT_APP_BRAND_FAVICON_PATH', '/marmin_favicon.ico'),
  brandLogoPath: readConfig('REACT_APP_BRAND_LOGO_PATH', '/marmin_logo.png'),
  brandName: readConfig('REACT_APP_BRAND_NAME', 'Dev Dashboard'),
  cookieDomain: readConfig('REACT_APP_COOKIE_DOMAIN'),
  helpAndSupportUrl: readConfig('REACT_APP_HELP_AND_SUPPORT_URL'),
  appEnvBanner: readConfig('REACT_APP_ENV_NAME', ''),
  vendorSlug: readConfig('REACT_APP_VENDOR_SLUG', 'marmin'),
  termsUrl: readConfig('REACT_APP_TERMS_URL'),
  privacyUrl: readConfig('REACT_APP_PRIVACY_URL'),
  docsBaseUrl: readConfig('REACT_APP_DOCS_BASE_URL', 'https://docs.ae.marmin.ai').replace(/\/$/, ''),
});

const updateLinkHref = (selector, href) => {
  if (!href) {
    return;
  }

  const linkElement = document.querySelector(selector);
  if (linkElement) {
    linkElement.href = href;
  }
};

export const applyDocumentBranding = () => {
  if (typeof document === 'undefined') {
    return;
  }

  document.title = `${appConfig.brandName} Dev Dashboard`;

  const descriptionElement = document.querySelector('meta[name="description"]');
  if (descriptionElement) {
    descriptionElement.setAttribute('content', `${appConfig.brandName} Dev Dashboard`);
  }

  updateLinkHref('link[rel="icon"]', appConfig.brandFaviconPath);
  updateLinkHref('link[rel="apple-touch-icon"]', appConfig.brandLogoPath);
};

export default appConfig;
